export type FormState = {
    clientId: string;
    name: string;
    abbreviation: string;
    description: string;
    clientPmName: string;
    clientPmEmail: string;
    clientPmPhone: string;
    agilePmName: string;
    agilePmEmail: string;
    agilePmPhone: string;
    overrideSlaEstimateEf: boolean;
    slaHoursEstimateEf: string;
    overrideSlaStartDev: boolean;
    slaHoursStartDev: string;
    overrideSlaAnalyzeBug: boolean;
    slaHoursAnalyzeBug: string;
    overrideSlaAnalyzeMinor: boolean;
    slaHoursAnalyzeMinor: string;
    overrideSlaDaysValidateDoc: boolean;
    slaDaysValidateDoc: string;
    overrideSlaMinScoreAi: boolean;
    slaMinScoreAi: string;
    overrideAiStrictnessLevel: boolean;
    aiStrictnessLevel: string;
    overrideAiExtraSystemPrompt: boolean;
    aiExtraSystemPrompt: string;
    overrideAiModel: boolean;
    aiModel: string;
    jiraProjectKey: string;
    jiraBaseUrl: string;
    reportsUrl: string;
};

export const EMPTY_FORM: FormState = {
    clientId: '',
    name: '',
    abbreviation: '',
    description: '',
    clientPmName: '',
    clientPmEmail: '',
    clientPmPhone: '',
    agilePmName: '',
    agilePmEmail: '',
    agilePmPhone: '',
    overrideSlaEstimateEf: false,
    slaHoursEstimateEf: '',
    overrideSlaStartDev: false,
    slaHoursStartDev: '',
    overrideSlaAnalyzeBug: false,
    slaHoursAnalyzeBug: '',
    overrideSlaAnalyzeMinor: false,
    slaHoursAnalyzeMinor: '',
    overrideSlaDaysValidateDoc: false,
    slaDaysValidateDoc: '',
    overrideSlaMinScoreAi: false,
    slaMinScoreAi: '',
    overrideAiStrictnessLevel: false,
    aiStrictnessLevel: '',
    overrideAiExtraSystemPrompt: false,
    aiExtraSystemPrompt: '',
    overrideAiModel: false,
    aiModel: '',
    jiraProjectKey: '',
    jiraBaseUrl: '',
    reportsUrl: ''
};
